import React from 'react';
import './style.css'
import { BG, LoginBack, PCLOGO } from '../../constants';

interface PCMSGuidedTourModalProps {
  show: boolean;
  onTakeTour: () => void;
  onMayBeLater: () => void;
}

const PCMSGuidedTourModal : React.FC<PCMSGuidedTourModalProps>= ({ show, onTakeTour, onMayBeLater }) => {
  if (!show) {
    return null;
  }

  // Simple inline styles to replicate the look
  const modalOverlayStyle:any = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  };

  const modalContentStyle = {
    backgroundColor: '#fff',
    borderRadius: '8px',
    overflow: 'hidden',
    width: '90%',
    padding:'16px 24px',
    maxWidth: '500px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  };

  const headerStyle:any = {
  
    color: '#fff',
    padding: '40px 20px',
    textAlign: 'center',
    minHeight: 210,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 16,
    borderRadius:'4px',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat'
  };


  const bodyStyle:any = {
   
    textAlign: 'left',
  };

  const welcomeTitleStyle = {
    fontSize:'16px',
fontStyle: 'normal',
fontWeight: '600',
lineHeight: '150%',
letterSpacing:' 0.15px',
marginTop:'32px',
marginBottom:'0'
  };

  const bodyTextStyle = {
    fontSize: '14px',
    color: '#333',
    marginBottom: '20px',
    marginTop:'0'
  };

  const footerStyle = {
    
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
  };

  const maybeLaterBtnStyle = {
    backgroundColor: '#fff',
    color: '#007CBF',
    borderRadius: '8px',
border: '1px solid  rgba(0, 124, 191, 0.50)',
    padding: '10px 20px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '600',

  };

  const takeTourBtnStyle = {
    backgroundColor: '#007CBF',
    color: '#fff',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '600',
  };

  return (
    <div style={modalOverlayStyle}>
      <div style={modalContentStyle}>
        {/* Header Section (Blue Background) */}
        <div  style={{...headerStyle, backgroundImage: `url(${BG})`, backgroundSize: 'cover' }}>
          
        </div>

        {/* Body Section (Welcome Text) */}
        <div style={bodyStyle}>
          <p style={welcomeTitleStyle}>Welcome to the PCMS Guided Tour</p>
          <p style={bodyTextStyle}>
            Let's walk you through the key features so you can get started quickly.
          </p>
        </div>

        {/* Footer Section (Buttons) */}
        <div style={footerStyle}>
          <button style={maybeLaterBtnStyle} onClick={onMayBeLater}>
            May be later
          </button>
          <button style={takeTourBtnStyle} onClick={onTakeTour}>
            Take a tour
          </button>
        </div>
      </div>
    </div>
  );
};

export default PCMSGuidedTourModal;